import { Typography, Box, Avatar } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'
import { Link, useParams } from 'react-router-dom'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PauseIcon from '@mui/icons-material/Pause';
import { pause, playTrack } from '../../services/MusicPlayerApi'
import withMK from '../../hoc/withMK'

interface SmallTrackRowProps extends MKProps {
    track: Track,
    color: string,
    onClick: any
}


const SmallTrackRow = (props: SmallTrackRowProps) => {
    let {track, color = '#FFFFFF', onClick, mk} = props
    let { id } = useParams()
    const currentTrackId = mk && mk.instance.queue.currentItem ? mk.instance.queue.currentItem.id : null
    const playing = mk?.instance?.isPlaying

    return <Box sx={{width: '100%', position: 'relative'}} onClick={onClick}>
        <Stack direction="row" sx={{p: 1}} alignItems={'center'}>
            { 
                 playing && track.apple_id+'' === currentTrackId+''
                    ? <Stack spacing={0} direction={'row'} alignItems={'center'} sx={{position: 'relative'}}>
                        <PauseIcon 
                            htmlColor='#fff' 
                            onClick={() => pause()} 
                            sx={{background: '#17043d',border: '4px solid #17043d', borderRadius: '50%', fontSize: '16pt', position: 'absolute', zIndex: 1, left: '50%', transform: 'translateX(-50%)'}}/>
                        <Avatar 
                            onClick={() => pause()}
                            variant="circular" 
                            alt={track.album.apple_name} 
                            src={track.album.apple_artwork_url?.replace("{w}","1200")?.replace("{h}","800")} 
                            sx={{width: '4vh', height: '4vh' }} />
                    </Stack>
                    : <Stack spacing={0} direction={'row'} alignItems={'center'} sx={{position: 'relative', '&:hover': {'& svg': {opacity: 1}}}}>
                         <PlayArrowIcon 
                                onClick={() => playTrack([new MusicKit.MediaItem({type: 'song', id: track.apple_id+''})], 0)} 
                                htmlColor='#fff' 
                                sx={{background: '#000',border: '4px solid #000', borderRadius: '50%', opacity: 0, fontSize: '16pt', position: 'absolute', zIndex: 1, left: '50%', transform: 'translateX(-50%)'}} />
                        <Avatar 
                            onClick={() => playTrack([new MusicKit.MediaItem({type: 'song', id: track.apple_id+''})], 0)}
                            variant='circular' 
                            alt={track?.album?.apple_name} 
                            src={track?.album?.apple_artwork_url?.replace("{w}","1200")?.replace("{h}","800")} 
                            sx={{ width: '4vh', height: '4vh' }} />
                    </Stack>

            }
            <Stack justifyContent="center" sx={{ marginLeft: '16px', width: '100%', color: 'white', '& a' : { textDecoration: 'none'} }}>
                <Typography sx={{fontWeight: 600, fontSize: '1rem','& a': { color: color, textDecoration: 'none'}}}><Link to={`/track/${track._id}`}>{`${track.apple_title.slice(0, 24)}${track.apple_title.length > 23 ? '...' : ''}`}</Link></Typography>
                <Stack direction="row" alignItems={'baseline'}>
                    <div>
                        {
                            track && track.main_artists.slice(0,2).map((artist, i) => {
                                return i === track.main_artists.length - 1 || i === 1
                                    ? artist._id === id ? artist.artist_name : <Link key={Date.now() + i + artist._id} to={`/artist/${artist._id}`}><Typography sx={{fontWeight: 300, fontStyle: 'italic', color: color, display: 'inline'}}>{artist.artist_name}</Typography></Link>
                                    : artist._id === id ? artist.artist_name + ', ' : <span key={Date.now() + i + artist._id}><Link key={Date.now() + i + artist._id} to={`/artist/${artist._id}`}><Typography sx={{fontWeight: 300, fontStyle: 'italic', color: color, display: 'inline'}}>{artist.artist_name}</Typography></Link>, </span>
                            })
                        }
                    </div>
                </Stack>
            </Stack>
        </Stack>
    </Box>
}


const bindings = {
    [MusicKit.Events.mediaItemDidChange]: 'mediaItem',
    [MusicKit.Events.queueItemsDidChange]: 'queueItems',
    [MusicKit.Events.queuePositionDidChange]: 'queuePosition',
    [MusicKit.Events.playbackStateDidChange]: 'playbackState',
}
  
export default withMK(SmallTrackRow, bindings)